import React, {useState, useEffect} from "react";
import SeatIcon from "./icons/Seat";
import classNames from "classnames";
import {addSeat, removeSeat} from "../actions/reservedSeats";
import {useDispatch, useSelector} from "react-redux";

export default function Seat(props) {
    const { carriage, number, announcedNumber, firstClass, available, active, reverse, compartmentTop, compartmentBottom } = props;

    const dispatch = useDispatch();
    const activeSeats = useSelector(state => state.activeSeats.seats);

    // Check if this seat is in the Redux store
    const isSeatActive = activeSeats.some(seat => seat.carriage === carriage && String(seat.seat) === String(number));
    const [isActive, setActive] = useState(isSeatActive);

    // Sync local state with Redux store when it changes
    useEffect(() => {
        setActive(isSeatActive);
    }, [isSeatActive]);

    const toggleActive = () => {
        if (! available) {
            return;
        }

        if (isActive) {
            dispatch(removeSeat(carriage, number))
        } else {
            dispatch(addSeat(carriage, number, announcedNumber, firstClass))
        }

        setActive(!isActive);
    }

    return (
        <button key={number} type="button" className={classNames("seat", {"available": available, "reverse": reverse, "active": isActive, "compartment-top": compartmentTop, "compartment-bottom": compartmentBottom, "cursor-default": !available})} onClick={toggleActive} >
            <SeatIcon />
            <span className={classNames("seat-number-single", {"seat-number-long": String(number).length > 2})}>{number}</span>
        </button>
    )
}
